import React from 'react';
import ItemList from './ItemList';

export default function ItemListContainer(){

    return(
        <>
            <ItemList/>
        </>
    )
}